import { observable, IObservableValue, action, computed } from 'mobx';
import { WebGivingPage } from '../index';
import { FormField } from '../../components/form-field';
import { ValidationState, validateFields } from '../../validation/view-model-validator';
import { CheckCodelessPaymentResult, Currency, ModelMetadata, PaymentLabel } from '../../webgiving-generated';
import { createRulesFromMetadata } from '../../validation/validation-rules';
import { WebGivingPageViewModelBase } from '../page-view-model-base';

export interface IPageConfirmMobileFastmodeInfo {
	currency?: Currency;
	confirmationReason?: number | null;
	fastModeDailyLimit?: number | null | undefined;
	fastModeAvailable?: boolean;
}

export class PageConfirmMobileNumberViewModel extends WebGivingPageViewModelBase {
	readonly type: WebGivingPage.ConfirmMobileNumber | WebGivingPage.ConfirmMobileNumberForPayment;
	securityCode: FormField<string>;

	@observable
	validationState?: ValidationState;

	@observable
	rememberMobileNumber = FormField.Unvalidated(false);

	payersMustBeVerified: boolean;

	@observable
	responseTimeNotice: boolean;

	validate(): ValidationState {
		return validateFields(this);
	}

	get canChangeMobileNumber() {
		return this.type === WebGivingPage.ConfirmMobileNumber;
	}

	constructor(public mobileNumber: string,
		type: WebGivingPage.ConfirmMobileNumber | WebGivingPage.ConfirmMobileNumberForPayment,
		public userIsRemembered: boolean,
		public resendCodeDisabled: IObservableValue<boolean>,
		public resetPasswordUrl: string,
		public paymentLabel: PaymentLabel,
		public fastmodeInfo: IPageConfirmMobileFastmodeInfo = {},
	) {
		super();
		this.type = type;
		this.securityCode = new FormField<string>('', createRulesFromMetadata(ModelMetadata.EnterMobileNumberConfirmCodeRequest.Code));
	}

	@action.bound
	setResponseTimeNotice(base: boolean) {
		this.responseTimeNotice = base;
	}

	@computed
	get showFastModeLimitError() {
		const {
			fastModeDailyLimit,
			confirmationReason,
			fastModeAvailable,
		} = this.fastmodeInfo;
		return (
			!!fastModeDailyLimit &&
			fastModeAvailable &&
			(confirmationReason ===
				CheckCodelessPaymentResult.PaymentsTotalOverDailyLimit ||
				confirmationReason ===
					CheckCodelessPaymentResult.PaymentOverDailyLimit)
		);
	}
}
